import { Validator, AbstractControl, NG_VALIDATORS, ValidatorFn } from '@angular/forms';
import { Directive } from '@angular/core';
import { LinehaulScheduleFormFields } from '../enums/linehaul-schedule-form-fields.enum';
import { ErrorWarningService } from '../components/payform/services/error-warning/error-warning.service';
import { WarningValidationType } from '../enums';
import { FormUtils } from '../classes';
import { LoDash } from '../utils/angular-utils/lodash-utils';

export function eslSoloValidatorFunction(errorWarningService: ErrorWarningService, schSequenceNbr: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control || control.disabled || !control.parent || !errorWarningService.shouldDisplayWarnings()) {
      return null;
    }

    if (!control.value && FormUtils.hasWarning(control, undefined, WarningValidationType.EslSoloWarning)) {
      FormUtils.unsetWarning(control, WarningValidationType.EslSoloWarning);
      errorWarningService.detailWarningsChanged(schSequenceNbr);
    }

    if (control.value) {
      const origin: string = LoDash.get(control.parent.get(LinehaulScheduleFormFields.OriginSicCd), 'value', '');
      const dest: string = LoDash.get(control.parent.get(LinehaulScheduleFormFields.DestinationSicCd), 'value', '');
      const eslSoloWarning = {
        type: WarningValidationType.EslSoloWarning,
        primarySubject: `${origin.toUpperCase()} -> ${dest.toUpperCase()}`,
      };

      FormUtils.setWarning(control, WarningValidationType.EslSoloWarning, eslSoloWarning);
      errorWarningService.detailWarningsChanged(schSequenceNbr);
    }

    return null;
  };
}

@Directive({
  selector: '[eslSoloValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: EslSoloValidator, multi: true }],
})
export class EslSoloValidator implements Validator {
  constructor(private errorWarningService: ErrorWarningService) {}
  private schSequenceNbr: string;

  validate(control: AbstractControl): { [key: string]: any } | null {
    return eslSoloValidatorFunction(this.errorWarningService, this.schSequenceNbr)(control);
  }
}
